import React from 'react';

import { ReactComponent as CloseIcon } from '../../assets/icons/close-icon.svg';
import MyButton from '../button/Button';

interface ActionItem {
  label: string;
  onClick?: () => void;
  icon?: JSX.Element;
  buttonType?:
  | 'submit'
  | 'back'
  | 'error'
  | 'gray'
  | 'outline'
  | 'active-outline'
  | 'warning'
  | 'primary-outline'
  | 'none'
  | 'hover'
  | 'danger-outline'
  | 'primary-outline-none'
  | 'primary';
  labelColorFill?: string;
  svgColorFill?: string;
}

interface CustomActionBarProperties {
  selectedRows: string[];
  actions: ActionItem[];
  onSelectedRowsChange?: (rows: string[]) => void;
}

/**
 * Custom Action Bar Component
 *
 * Displays a floating action bar when items are selected.
 *
 * @component
 * @param {CustomActionBarProperties} props - Component properties
 * @returns {JSX.Element}
 */
function CustomActionBar({
  selectedRows,
  actions,
  onSelectedRowsChange,
}: CustomActionBarProperties) {
  if (!selectedRows || selectedRows.length === 0) {
    return null;
  }

  return (
    <div className="custom-action-bar-wrap">
      <div className="actions-row">
        <div className="left-section">
          {onSelectedRowsChange && (
            <span
              role="presentation"
              className="close-icon"
              onClick={() => onSelectedRowsChange([])}>
              <CloseIcon />
            </span>
          )}
          <span className="item-count">
            {selectedRows.length.toString().padStart(2, '0')}{' '}
            {selectedRows.length === 1 ? 'Item Selected' : 'Items Selected'}
          </span>
        </div>

        <div className="vertical-separator" />

        <div className="btn-group">
          {actions.map((action, index) => (
            <React.Fragment key={index}>
              <MyButton
                label={action.label}
                svgIcon={action.icon}
                buttonType={action.buttonType || 'primary'}
                onClickFunc={action.onClick}
                labelColorFill={action.labelColorFill}
                svgColorFill={action.svgColorFill}
              />
              {index < actions.length - 1 && <div className="vertical-separator" />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

CustomActionBar.defaultProps = {
  onSelectedRowsChange: null,
};

export default CustomActionBar;
